import { render, staticRenderFns } from "./CustomReports.vue?vue&type=template&id=2f07d4e5&scoped=true&"
import script from "./CustomReports.vue?vue&type=script&lang=js&"
export * from "./CustomReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07d4e5",
  null
  
)

export default component.exports